function aboutScentButton() {
    return document.querySelector("#about-scent .about-scent-cta");
}

function syncAboutScentCta() {
    var button = aboutScentButton();
    var app = window.productApp;

    if (!button || button.classList.contains("added")) return;
    if (!app || !app.state || !app.state.variant || !app.state.variant.id) return;

    var variant = app.state.variant;
    var bundle = app.state.bundle;
    var unavailable = variant.available === false || (bundle && bundle.is_bundle && bundle.all_available === false);
    var isSubscription = app.state.subscription && app.state.subscription.is_selected;
    var defaultLabel = button.getAttribute("data-default-label") || "add to bag";

    if (unavailable) {
        button.textContent = "Notify Me When Back in Stock";
        button.setAttribute("data-cta", "notify");
    } else if (isSubscription) {
        button.textContent = "subscribe";
        button.setAttribute("data-cta", "subscription");
    } else {
        button.textContent = defaultLabel;
        button.setAttribute("data-cta", "one-time");
    }
}

function watchProductSelection() {
    if (!window.productApp || typeof window.productApp.$watch !== "function") {
        window.setTimeout(watchProductSelection, 200);
        return;
    }

    window.productApp.$watch("state", syncAboutScentCta, { deep: true });
    syncAboutScentCta();
}

function addFallbackVariant(variantId, button) {
    var cartItems = {
        quantity: 1,
        id: variantId,
        properties: {
            "_is_bundle": false,
            "_Type": "OneTimePurchase",
            "_attribution": "One Time Purchase"
        }
    };

    $.ajax({
        url: "/cart/add.json",
        type: "post",
        dataType: "json",
        data: cartItems,
        success: function (response) {
            console.log("");
            console.log("%c" + response.title + "%c was added to cart.", "color: green", "color: black");

            if (showVueCart == true) {
                window.miniCart.refreshCart();
            }
        },
        error: function (response) {
            var errors = JSON.parse(response.responseText);
            console.log(errors.errors);
        }
    });

    if (!button) return;

    var defaultLabel = button.getAttribute("data-default-label") || "add to bag";
    button.classList.add("added");
    button.textContent = "Added!";

    window.setTimeout(function () {
        button.textContent = defaultLabel;
        button.classList.remove("added");
    }, 2500);
}

function addItemToBag(event) {
    var button = aboutScentButton();
    var app = window.productApp;

    if (app && app.state && app.state.variant && app.state.variant.id && typeof app.addItemToBag === "function") {
        var cta = button ? button.getAttribute("data-cta") : "one-time";
        var unavailable = app.state.variant.available === false || (app.state.bundle && app.state.bundle.is_bundle && app.state.bundle.all_available === false);

        if (cta === "notify" || unavailable) {
            if (typeof app.backInStockForm === "function") {
                app.backInStockForm();
            }
            return;
        }

        var option = (cta === "subscription" || (app.state.subscription && app.state.subscription.is_selected)) ? "subscription" : "one-time";

        if (button) button.classList.remove("addToCart");
        app.addItemToBag(event, option);

        if (button) {
            button.classList.add("addToCart", "added");
            button.textContent = option === "subscription" ? "Subscription Added!" : "Added!";
            window.setTimeout(function () {
                button.classList.remove("added");
                syncAboutScentCta();
            }, 2500);
        }
        return;
    }

    var variantId = button && button.getAttribute("data-fallback-variant");
    if (variantId) addFallbackVariant(variantId, button);
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", watchProductSelection);
} else {
    watchProductSelection();
}
